import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Appointment } from 'src/app/calendar/interfaces/appointment';
import * as ics from 'ics'
import { CustomerDto } from 'src/app/auth/interfaces/customer_dto';
import { StudentDto } from 'src/app/students/interfaces/student_dto';
import { AppointmentDto } from 'src/app/calendar/interfaces/appointment_dto';

@Injectable({
  providedIn: 'root',
})
export class IcsService {
      
    replaceUmlaute(str) {
    const umlautMap = {
        '\u00dc': 'UE',
        '\u00c4': 'AE',
        '\u00d6': 'OE',
        '\u00fc': 'ue',
        '\u00e4': 'ae',
        '\u00f6': 'oe',
        '\u00df': 'ss',
    }
    return str
        .replace(/[\u00dc|\u00c4|\u00d6][a-z]/g, (a) => {
        const big = umlautMap[a.slice(0, 1)];
        return big.charAt(0) + big.charAt(1).toLowerCase() + a.slice(1);
        })
        .replace(new RegExp('['+Object.keys(umlautMap).join('|')+']',"g"),
        (a) => umlautMap[a]
        );
    }

  async generateIcsFile(appointment: AppointmentDto, customer: CustomerDto, student: StudentDto): Promise<string> {

    let year = new Date(appointment.StartTime).getFullYear();
    let month = new Date(appointment.StartTime).getMonth() + 1;
    let day = new Date(appointment.StartTime).getDate();
    let hour = new Date(appointment.StartTime).getHours();
    let minute = new Date(appointment.StartTime).getMinutes();

    let duration = new Date(appointment.EndTime).getTime() - new Date(appointment.StartTime).getTime();
    let durationHours = Math.floor(duration / 3600000);
    let durationMinutes = Math.floor((duration % 3600000) / 60000);

    let returnValue;

    const event = {
        start: [year, month, day, hour, minute] as ics.DateTime,
        duration: { hours: durationHours, minutes: durationMinutes },
        title: this.replaceUmlaute(appointment.Type),
        description: this.replaceUmlaute(appointment.Subject),
        location: appointment.Location ? this.replaceUmlaute(appointment.Location) : '',
        alarms: [
            { trigger: { minutes: 30 } as ics.DurationObject, action: 'display' as ics.ActionType },
            { trigger: { days: 1 } as ics.DurationObject, action: 'display' as ics.ActionType },
        ],
        categories: [appointment.Type ? this.replaceUmlaute(appointment.Type) : ''],
        geo: { lat: 0, lon: 0 },
        url: 'https://www.quickdrive.ch',
        status: 'CONFIRMED' as ics.EventStatus,
        busyStatus: "BUSY" as "BUSY",
        organizer: { name: this.replaceUmlaute(customer.forename), email: customer.mail_customer },
        attendees: [
          { name: this.replaceUmlaute(student.forename) + " " + this.replaceUmlaute(student.surname), email: student.mail_student, rsvp: true, partstat: 'ACCEPTED' as ics.ParticipationStatus, role: 'REQ-PARTICIPANT' as ics.ParticipationRole },
        ]
      }
      
      await ics.createEvent(event, (error, value) => {
        if (error) {
          return
        }

        returnValue = value;
      })

      const base64 = btoa(returnValue);
      return base64;
  }

}
